// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const samurott_hisui: PokeData = {
  "id": 10236,
  "name": "samurott-hisui",
  "height": 15,
  "weight": 582,
  "base_experience": 238,
  "types": [
    PokeType.WATER,
    PokeType.DARK
  ],
  "api_moves": [
    "swords-dance",
    "tackle",
    "tail-whip",
    "water-gun",
    "hydro-pump",
    "focus-energy",
    "slash",
    "fury-cutter",
    "megahorn",
    "encore",
    "aerial-ace",
    "water-pulse",
    "sucker-punch",
    "dark-pulse",
    "night-slash",
    "aqua-tail",
    "aqua-jet",
    "retaliate",
    "razor-shell",
    "ceaseless-edge"
  ],
  "moves": [
    "tackle",
    "hydro-pump",
    "aerial-ace",
    "dark-pulse",
    "night-slash",
    "aqua-tail",
    "aqua-jet",
    "snarl",
    "water-spout",
    "crunch",
    "rain-dance",
    "brine",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 258,
    "item": null,
    "species": [
      {
        "name": "oshawott",
        "order": 502,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dewott",
        "order": 503,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 501,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "samurott",
        "order": 504,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 502,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 119,
    "speed": 124,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "hisui"
} as const;
